import React from "react";
import { useLocation } from "react-router-dom";

const NotificationBar = ({
  showNotification,
  getToken,
  NotificationData,
  currentPath,
  handleCookiesForShow,
  reactIcons
}) => {
  const { pathname } = useLocation();
  if (showNotification) return null;
  const getNotifications = (notifications) => {
    return notifications.map((item, index) => (
      <span
        key={index}
        className={item?.type === "Info" ? "text-green-500" : "text-[#ed0101]"}
      >
        <span className="font-semibold">{item.title}</span> : {item.description}
      </span>
    ));
  };

  const afterLoginNotifications = NotificationData?.AfterLogin?.filter(
    (item) =>
      item.displayPage === "/all" ||
      item.displayPage === currentPath ||
      pathname.startsWith(item.displayPage)
  );

  const beforeLoginNotifications = NotificationData?.BeforeLogin?.filter(
    (item) => item.displayPage === "/all"
  );

  return Boolean(getToken) && afterLoginNotifications?.length > 0 ? (
    <div className="h-[40px] relative w-full bg-black border-b text-white flex items-center border-white">
      <marquee behavior="scroll" direction="left" scrollamount="8">
        <div className="flex gap-5">
          {getNotifications(afterLoginNotifications)}
        </div>
      </marquee>
      <div
        onClick={handleCookiesForShow}
        className="absolute bg-black p-2 right-0 flex justify-center items-center cursor-pointer"
      >
        {reactIcons.close}
      </div>
    </div>
  ) : !Boolean(getToken) && beforeLoginNotifications?.length > 0 ? (
    <div className="h-[40px] relative w-full bg-black border-b text-white flex items-center border-white">
      <marquee behavior="scroll" direction="left" scrollamount="8">
        <div className="flex gap-5 lg:gap-10">
          {getNotifications(beforeLoginNotifications)}
        </div>
      </marquee>
      <div
        onClick={handleCookiesForShow}
        className="absolute bg-black p-2 right-0 flex justify-center items-center cursor-pointer"
      >
        {reactIcons.close}
      </div>
    </div>
  ) : null;
};

export default NotificationBar;
